module.exports = __webpack_public_path__ + "img/warning.28cbecb9.png";